import React, { Fragment } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon, SelectorIcon } from "@heroicons/react/solid";
import { packClasses } from "Utils";
import BaseElement from "./BaseElement";

export default function LowSelectBox(props) {
    const defaultProps = {
        label: "Select Box",
        id: "select-box",
        name: "select-box",
        value: "",
        helpertext: false,
        options: {},
        onChange: () => {},
    };
    const useProps = Object.assign(defaultProps, {}, props);

    // Return a faux event back to formik
    const onChange = (val) => {
        if (props.onChange) {
            props.onChange(
                props.value instanceof Object
                    ? props.options.find((i) => i.value === val)
                    : val
            );
        }
    };

    let lbl = "Label";
    if (props.value === null) {
        lbl = "Select";
    } else if (
        (typeof props.value === "number" || typeof props.value === "string") &&
        props.options.length &&
        props.options[0] instanceof Object
    ) {
        lbl = props.options.find((i) => i.value === props.value)?.label;
    } else if (props.value instanceof Object) {
        lbl = props.value.label;
    } else {
        lbl = props.value;
    }

    const input = (
        <div className="sm:col-span-6">
            <div className="mt-1">
                <Listbox
                    value={
                        props.value instanceof Object
                            ? props.value.value
                            : props.value
                    }
                    onChange={onChange}
                    disabled={props.disabled}
                >
                    {({ open }) => (
                        <Fragment>
                            <div className="relative mt-1">
                                <Listbox.Button className="focus:outline-none relative w-full cursor-default rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-left shadow-sm focus:border-green-500 focus:ring-1 focus:ring-green-500 disabled:opacity-50 sm:text-sm">
                                    <span className="block truncate">
                                        {lbl}
                                    </span>
                                    <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                        <SelectorIcon
                                            className="h-5 w-5 text-gray-400"
                                            aria-hidden="true"
                                        />
                                    </span>
                                </Listbox.Button>

                                <Transition
                                    show={open}
                                    as={Fragment}
                                    leave="transition ease-in duration-100"
                                    leaveFrom="opacity-100"
                                    leaveTo="opacity-0"
                                >
                                    <Listbox.Options
                                        static
                                        className="focus:outline-none absolute z-30 mt-1 max-h-60 w-full min-w-max overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 sm:text-sm"
                                    >
                                        {props.options.map((item, i) => (
                                            <Listbox.Option
                                                key={
                                                    item instanceof Object
                                                        ? item.value
                                                        : i
                                                }
                                                className={({ active }) =>
                                                    packClasses(
                                                        active
                                                            ? "bg-green-600 text-white"
                                                            : "text-gray-900",
                                                        "relative cursor-default select-none py-2 pl-8 pr-4"
                                                    )
                                                }
                                                value={
                                                    item instanceof Object
                                                        ? item.value
                                                        : item
                                                }
                                            >
                                                {({ selected, active }) => (
                                                    <Fragment>
                                                        <span
                                                            className={packClasses(
                                                                selected
                                                                    ? "font-semibold"
                                                                    : "font-normal",
                                                                "block truncate"
                                                            )}
                                                        >
                                                            {item instanceof
                                                            Object
                                                                ? item.label
                                                                : item}
                                                        </span>

                                                        {selected ? (
                                                            <span
                                                                className={packClasses(
                                                                    active
                                                                        ? "text-white"
                                                                        : "text-green-600",
                                                                    "absolute inset-y-0 left-0 flex items-center pl-1.5"
                                                                )}
                                                            >
                                                                <CheckIcon
                                                                    className="h-5 w-5"
                                                                    aria-hidden="true"
                                                                />
                                                            </span>
                                                        ) : null}
                                                    </Fragment>
                                                )}
                                            </Listbox.Option>
                                        ))}
                                    </Listbox.Options>
                                </Transition>
                            </div>
                        </Fragment>
                    )}
                </Listbox>
            </div>
        </div>
    );

    const helperText = useProps.helpertext ? (
        <p className="mt-1.5 text-xs text-gray-500">{useProps.helpertext}</p>
    ) : (
        ""
    );

    const label = (
        <label
            htmlFor={useProps.id}
            className="block text-sm font-medium text-gray-700"
        >
            {props.label}
        </label>
    );

    return (
        <BaseElement
            {...useProps}
            input={input}
            label={label}
            helpertext={helperText}
            errortext=""
        />
    );
}
